import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import AdminGridItem from './AdminGridItem';
import '../../styles/AdminGrid.css';

interface AdminSectionProps {
  title: string;
  icon: IconDefinition;
  description: string;
  onClick: () => void;
}

interface AdminGridProps {
  sections: AdminSectionProps[];
}

/**
 * AdminGrid component - Displays a grid of admin sections for navigation
 */
const AdminGrid: React.FC<AdminGridProps> = ({ sections }) => {
  return (
    <div className="admin-dashboard-grid">
      {sections.map((section, index) => (
        <AdminGridItem
          key={index}
          title={section.title}
          icon={section.icon}
          description={section.description}
          onClick={section.onClick}
        />
      ))}
    </div>
  );
};

export default AdminGrid;
